module.exports = __webpack_public_path__ + "static/logo-fleet-advantage-166753f526e07a460015462eda0e2745.webp";